import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-grid-system';
import H1 from '../../atoms/title/H1';
import Layout from '../../templates/Layout';
import PaginationList from '../../molecules/PaginationList';
import { router } from '@inertiajs/react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import DossierTable from '../../organisms/table/DossierRequestsTable';
import Notice from '../../molecules/Notice';
const Overview = ({ dossiers, notice }) => {
    const { t } = useTranslation();
    const [page, setPage] = useState(dossiers.current_page);
    const [loading, setLoading] = useState(false);
    router.on('finish', event => {
        if (!event.detail.visit.interrupted) {
            setLoading(false);
        }
    });
    const reload = () => {
        // Do not use `Inertia.reload()` here
        // @see {@link https://github.com/inertiajs/inertia/issues/65}
        // Simply put: array params will duplicate and the URL becomes a mess.
        // Hours wasted here = 4
        router.replace(location.pathname, {
            data: { page },
            only: ['dossiers'],
        });
    };
    useEffect(() => {
        if (dossiers.current_page !== page) {
            reload();
        }
    }, [page]);
    return (_jsxs(Layout, { "data-testid": "dossier-request-overview", children: [_jsx(Helmet, { children: _jsx("title", { children: t('dossiers.requests.title') }) }), _jsx(H1, { "data-testid": "title", children: t('dossiers.requests.title') }), notice && _jsx(Notice, { ...notice }), _jsx(Row, { children: _jsxs(Col, { sm: 12, children: [_jsx(DossierTable, { loading: loading, dossiers: dossiers.data }), _jsx(PaginationList, { disabled: loading, links: dossiers.links, setPage: setPage })] }) })] }));
};
export default Overview;
